export default function imageUrlReplace(url: string) {
  const siteDomain = `${process.env["NEXT_PUBLIC_SITE_URL"]}`;
  const wordpressDomain = `${process.env["NEXT_PUBLIC_WORDPRESS_URL"]}`;

  // Returns the url from our wordpress domain if it has been overwritten by faust
  return url.includes(wordpressDomain)
    ? url.replace(wordpressDomain + "/wp-content", siteDomain)
    : url;
}
